import { render, staticRenderFns } from "./SelectPlan.vue?vue&type=template&id=1067d0d4&scoped=true&"
import script from "./SelectPlan.vue?vue&type=script&lang=js&"
export * from "./SelectPlan.vue?vue&type=script&lang=js&"
import style0 from "./SelectPlan.vue?vue&type=style&index=0&id=1067d0d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1067d0d4",
  null
  
)

export default component.exports